export const useQueryParams = (queryParams: string, param: string) => {
  return new URLSearchParams(queryParams).get(param) || ''
}
